export default "__VITE_ASSET__eb38e206__"